<template>
  <FormsBase />
</template>

<script>
import FormsBase from '../components/Prospect/FormsBase.vue';

export default {
  name: 'RegistrationView',

  components: {
    FormsBase,
  },
};
</script>
